import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import AutoSuggest, { type AutoSuggestSuggestion } from '@rio-cloud/rio-uikit/AutoSuggest';
import { AutoSuggestProps } from '@rio-cloud/rio-uikit/types';

interface AutoSuggestOTAProps {
    hasError?: boolean;
    labelId?: string;
    options?: string[];
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
}

const AutoSuggestOTA: React.FC<AutoSuggestOTAProps & Partial<AutoSuggestProps>> = (props) => {
    const [suggestions, setSuggestions] = useState<AutoSuggestSuggestion[]>([]);

    const highlightError = props.hasError ? 'form-group has-feedback has-error' : '';

    const handleSuggestionsFetchRequested = (result: { value: string }) => {
        const newValue = result.value;
        if (props.onChange) {
            props.onChange(newValue);
        }
        const filteredSuggestions = props.options
            .filter(option => option?.toLowerCase().includes(newValue?.toLowerCase()))
            .map(option => ({ label: option }));
        setSuggestions(filteredSuggestions);
    };

    const renderSuggestion = (suggestion: AutoSuggestSuggestion) => <span>{suggestion.label}</span>;

    const handleSuggestionSelected = (event: any, { suggestion }: { suggestion: AutoSuggestSuggestion }) => {
        if (props.onChange) {
            props.onChange(suggestion.label);
        }
    };

    return (
        <>

            <div className='form-group'>{props.labelId &&
                <label className='control-label'>
                    <FormattedMessage id={props.labelId}/>
                </label>}
                <AutoSuggest
                    className={highlightError}
                    inputProps={{ ...props.inputProps, value: props.value || '', placeholder: props.placeholder }}
                    suggestions={props.suggestions || suggestions}
                    onSuggestionsFetchRequested={props.onSuggestionsFetchRequested || handleSuggestionsFetchRequested}
                    onSuggestionSelected={props.onSuggestionSelected || handleSuggestionSelected}
                    renderSuggestion={renderSuggestion}
                    openOnFocus
                />
            </div>

            {props.hasError && (
                <div className={'form-group has-feedback has-error'}>
                            <span className='help-block'>
                                <span><FormattedMessage id='intl-msg:form:requiredField'/></span>
                            </span>
                </div>
            )}
        </>

    );
};

export default AutoSuggestOTA;
